import { reactive, readonly } from 'vue'
import { DateTime } from 'luxon'

const state = reactive({
  id: undefined,
  name: undefined,
  preferred_iana_zone: undefined,
  account: {},
  roles: [],
})

const methods = {
  getId() {
    return state.id
  },
  setId(id) {
    state.id = id
  },
  getName() {
    return state.name
  },
  setName(name) {
    state.name = name
  },
  getAccount() {
    return state.account
  },
  setAccount(account) {
    state.account = account
  },
  getRoles() {
    return state.roles
  },
  setRoles(roles) {
    state.roles = roles
  },
  getPreferredTimeZone() {
    return state.preferred_iana_zone
  },
  setPreferredTimeZone(timezone) {
    state.preferred_iana_zone = timezone
  },
  getEffectiveTimeZone() {
    const dateObj = state.preferred_iana_zone
      ? DateTime.fromJSDate(new Date(), { zone: state.preferred_iana_zone })
      : DateTime.fromJSDate(new Date())
    return dateObj.toFormat('z')
  },
  getEffectiveTimeZoneNamedOffset() {
   return DateTime.fromJSDate(new Date(), { zone: this.getEffectiveTimeZone() }).toFormat('ZZZZZ')
  },
  /**
   * @param {string} roleName
   * @returns {boolean}
   */
  hasRole(roleName) {
    return state.roles.map(role => role.name).indexOf(roleName) !== -1
  },
  /**
   * @param {array} roleNameList
   * @returns {boolean}
   */
  hasAllRoles(roleNameList) {
    const userRoleNames = state.roles.map(role => role.name)
    let result = true
    roleNameList.every((name) => {
      if (userRoleNames.indexOf(name) === -1) {
        result = false
        return false // break out of "every" loop after the first name that is NOT found
      }
      return true
    })
    return result // return true if all names are found
  },
  /**
   * @param {array} roleNameList
   * @returns {boolean}
   */
  hasAnyRoles(roleNameList) {
    const userRoleNames = state.roles.map(role => role.name)
    let result = false
    roleNameList.every((name) => {
      if (userRoleNames.indexOf(name) !== -1) {
        result = true
        return false  // break out of "every" loop after the first name that is found
      }
      return true
    })
    return result // return false if none of the names are found
  },
}

export default {
  name: 'UserDetailsStore',
  state: readonly(state),
  methods,
}
